var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 508.583 508.583",
    height: 512,
    viewBox: "0 0 508.583 508.583",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.502,
    x2: 279.511,
    xlinkHref: "#lg1",
    y1: 440.555,
    y2: 440.555
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.38,
    x2: 247.046,
    y1: 432.792,
    y2: 348.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.606,
    x2: 349.093,
    y1: -28.766,
    y2: 317.717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.783,
    x2: 173.718,
    y1: 301.138,
    y2: 110.074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.886,
    x2: 272.4,
    xlinkHref: "#lg1",
    y1: 72.267,
    y2: 368.228
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m265.544 508.583h-22.505c-14.314 0-25.917-11.604-25.917-25.917v-110.14h74.34v110.14c0 14.314-11.604 25.917-25.918 25.917z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.122 387.182 74.34 74.34v-88.996h-74.34z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m382.854 387.987h-257.125c-14.543 0-26.332-11.789-26.332-26.332v-335.323c0-14.543 11.789-26.332 26.332-26.332h257.125c14.543 0 26.332 11.789 26.332 26.332v335.322c0 14.544-11.789 26.333-26.332 26.333z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.09 368.833h-217.597c-13.791 0-25.01-11.219-25.01-25.01v-299.66c0-13.791 11.219-25.01 25.01-25.01h217.597c13.791 0 25.01 11.219 25.01 25.01v299.66c0 13.791-11.219 25.01-25.01 25.01zm-217.597-331.679c-3.865 0-7.01 3.145-7.01 7.01v299.66c0 3.865 3.145 7.01 7.01 7.01h217.597c3.865 0 7.01-3.145 7.01-7.01v-299.661c0-3.865-3.145-7.01-7.01-7.01h-217.597z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.998 103.056c-12.381-16.696-32.98-19.233-56.701-19.233h-60.518c-10.213 0-12.598 2.103-12.598 9.411v185.89c0 5.898.217 9.952 6.462 12.121l96.743 96.743h86.468c14.543 0 26.332-11.789 26.332-26.332v-172.41z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.837 93.233c0-7.307 6.722-13.737 16.952-13.737h60.499c38.58 0 68.975 18.12 68.975 67.221v1.461c0 49.101-31.565 67.806-71.898 67.806h-28.935v63.13c0 9.353-11.399 14.029-22.796 14.029-11.399 0-22.797-4.676-22.797-14.029zm45.593 26.012v61.668h28.934c16.368 0 26.304-9.353 26.304-29.227v-3.215c0-19.874-9.937-29.226-26.304-29.226z",
    fill: "url(#SVGID_5_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParking);
export default __webpack_public_path__ + "static/media/icon-parking.76e30f6e3ba7880721cd924c4645db0c.svg";
export { ForwardRef as ReactComponent };